import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-25a3d6b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-themes card-outline card-outline-tabs mb-0 direct-chat direct-chat-primary" }
const _hoisted_2 = { class: "card-header p-0 border-bottom-0" }
const _hoisted_3 = { class: "nav nav-tabs" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = {
  ref: "chatMessagesList",
  class: "direct-chat-messages"
}
const _hoisted_9 = {
  key: 0,
  class: "direct-chat-msg system-msg"
}
const _hoisted_10 = { class: "text-gray text-center" }
const _hoisted_11 = { class: "direct-chat-infos clearfix" }
const _hoisted_12 = {
  key: 0,
  class: "badge bg-themes ml-1"
}
const _hoisted_13 = {
  key: 0,
  class: "badge bg-themes ml-1"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direct-chat-img hand",
  src: _imports_0
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "direct-chat-text" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "card-footer" }
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = { class: "input-group-append" }
const _hoisted_24 = {
  type: "submit",
  class: "btn btn-themes"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "nav flex-column" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = { class: "nav-link" }
const _hoisted_30 = { class: "nav-item" }
const _hoisted_31 = { class: "nav-link" }
const _hoisted_32 = { class: "nav-item" }
const _hoisted_33 = { class: "nav-link" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 工单状态 ")
const _hoisted_35 = { class: "float-right" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = { class: "nav-link" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 工单进度 ")
const _hoisted_39 = { class: "float-right" }
const _hoisted_40 = { class: "nav-item" }
const _hoisted_41 = { class: "nav-link" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 发起时间 ")
const _hoisted_43 = { class: "float-right" }
const _hoisted_44 = { class: "nav-item" }
const _hoisted_45 = { class: "nav-link" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 最后回复 ")
const _hoisted_47 = { class: "float-right" }
const _hoisted_48 = { class: "nav-item" }
const _hoisted_49 = { class: "nav-link" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 完成时间 ")
const _hoisted_51 = { class: "float-right" }
const _hoisted_52 = { class: "nav-item" }
const _hoisted_53 = { class: "nav-link" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" 所属设备 ")
const _hoisted_55 = { class: "float-right" }
const _hoisted_56 = { class: "nav-item" }
const _hoisted_57 = { class: "nav-link" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 发起人 ")
const _hoisted_59 = { class: "float-right" }
const _hoisted_60 = { class: "nav-item" }
const _hoisted_61 = { class: "nav-link" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" 星级 ")
const _hoisted_63 = { class: "float-right" }
const _hoisted_64 = { class: "nav-item" }
const _hoisted_65 = { class: "nav-link" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" 故障类型 ")
const _hoisted_67 = { class: "nav-item" }
const _hoisted_68 = { class: "nav-link" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" 影响范围 ")
const _hoisted_70 = { class: "nav-item" }
const _hoisted_71 = { class: "nav-link" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" 项目责任人 ")
const _hoisted_73 = { class: "nav-item" }
const _hoisted_74 = { class: "nav-link" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" 运维责任人 ")
const _hoisted_76 = { class: "nav-item" }
const _hoisted_77 = { class: "nav-link" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" 信息责任人 ")
const _hoisted_79 = { class: "nav-item" }
const _hoisted_80 = { class: "nav-link" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" 集成责任人 ")
const _hoisted_82 = { class: "content-modal" }

export function render(_ctx, _cache) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_star = _resolveComponent("app-star")
  const _component_app_select_level = _resolveComponent("app-select-level")
  const _component_app_model_textarea = _resolveComponent("app-model-textarea")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createBlock(_component_app_modal, {
    ref: "viewModal",
    title: '查看工单 (' + _ctx.infoData.workCode + ')',
    loading: _ctx.loading,
    showCloseButton: false,
    showSubmitButton: false,
    size: "lg",
    "onUpdate:modelOpened": _ctx.modelOpened,
    "onUpdate:modelClosed": _ctx.modelClosed
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link text-themes hand", {'active' : _ctx.activeTab === 'COMMON1'}]),
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.setActiveTab('COMMON1')))
              }, "消息", 2)
            ]),
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link text-themes hand", {'active' : _ctx.activeTab === 'COMMON2'}]),
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.setActiveTab('COMMON2')))
              }, "详情", 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane", {'active show' : _ctx.activeTab === 'COMMON1'}])
            }, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoList, (item, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                    (item.tags === 'sys')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_svg_icon, {
                              name: "information-circle-outline",
                              class: "mt--1 mr-1"
                            }),
                            _createTextVNode(_toDisplayString(item.infoData), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["direct-chat-msg", {'right':item.send===_ctx.authUser.userName}])
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["direct-chat-name", item.send===_ctx.authUser.userName?'float-right':'float-left'])
                            }, [
                              (item.send===_ctx.authUser.userName)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (!_ctx.$tools.isEmpty(item.tags))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.tags), 1))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(item.realName), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (!_ctx.$tools.isEmpty(item.tags))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.tags), 1))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(item.realName), 1)
                                  ], 64))
                            ], 2)
                          ]),
                          _createElementVNode("div", {
                            onClick: $event => (_ctx.nameSelectHandle(item.infoId))
                          }, _hoisted_16, 8, _hoisted_14),
                          _withDirectives(_createElementVNode("div", {
                            class: _normalizeClass(["nameSelectBox", item.send===_ctx.authUser.userName?'absolute-right':'absolute-left'])
                          }, [
                            _createTextVNode(_toDisplayString(item.orgName), 1),
                            _hoisted_17,
                            _createTextVNode(_toDisplayString(item.deptIdName), 1),
                            _hoisted_18,
                            _createTextVNode(_toDisplayString(item.realName), 1)
                          ], 2), [
                            [_vShow, _ctx.nameSelect[item.infoId]]
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", {
                              class: _normalizeClass({'bg-themes':item.send===_ctx.authUser.userName}),
                              innerHTML: item.infoData
                            }, null, 10, _hoisted_20),
                            _createElementVNode("div", {
                              class: _normalizeClass(["direct-chat-timestamp", item.send===_ctx.authUser.userName?'float-right':'float-left'])
                            }, _toDisplayString(item.createTime), 3)
                          ])
                        ], 2))
                  ], 64))
                }), 128))
              ], 512),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    ref: "chatInput",
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.message) = $event)),
                    placeholder: "请输入内容",
                    class: "form-control",
                    onKeyup: _cache[3] || (_cache[3] = _withKeys($event => (_ctx.chatSubmit({infoData: _ctx.message})), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.message]
                  ]),
                  _createElementVNode("span", _hoisted_23, [
                    _createElementVNode("button", _hoisted_24, [
                      _createVNode(_component_svg_icon, { name: "camera-outline" })
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-themes",
                      onClick: _cache[4] || (_cache[4] = $event => (_ctx.chatSubmit({infoData: _ctx.message})))
                    }, "发送")
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane", {'active show' : _ctx.activeTab === 'COMMON2'}])
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("ul", _hoisted_27, [
                    _createElementVNode("li", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["font-weight-bolder", {'hyper-text-themes': _ctx.modRoleAuth('/aftersale/ticket/works/modWorkDescribeLaunch', _ctx.infoData.userCode)}]),
                          onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.workDescribeLaunchModalOpen && _ctx.workDescribeLaunchModalOpen(...args)))
                        }, " 发起详情： ", 2),
                        _createTextVNode(" " + _toDisplayString(_ctx.infoData.workDescribeLaunch || '无'), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["font-weight-bolder", {'hyper-text-themes': _ctx.modRoleAuth('/aftersale/ticket/works/modWorkDescribeProcess', _ctx.infoData.userCode)}]),
                          onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.workDescribeProcessModalOpen && _ctx.workDescribeProcessModalOpen(...args)))
                        }, " 处理详情： ", 2),
                        _createTextVNode(" " + _toDisplayString(_ctx.infoData.workDescribeProcess || '无'), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.infoData.workStatusName), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.infoData.workSchedule) + "%", 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.infoData.createTime), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.infoData.lastReplyTime), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.infoData.completeTime), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.infoData.projectIdName), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.infoData.sendOrgName) + "-" + _toDisplayString(_ctx.infoData.sendDeptIdName) + "-" + _toDisplayString(_ctx.infoData.sendRealName), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _hoisted_62,
                        _createElementVNode("span", _hoisted_63, [
                          _createVNode(_component_app_star, {
                            val: _ctx.infoData.workStar
                          }, null, 8, ["val"])
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-right", {'hyper-text-themes': _ctx.modRoleAuth('/aftersale/ticket/works/modBusinessId', _ctx.infoData.userCode)}]),
                          onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.businessIdLevelModalOpen && _ctx.businessIdLevelModalOpen(...args)))
                        }, _toDisplayString(_ctx.infoData.businessIdName), 3)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-right", {'hyper-text-themes': _ctx.modRoleAuth('/aftersale/ticket/works/modInfluenceId', _ctx.infoData.userCode)}]),
                          onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.influenceIdLevelModalOpen && _ctx.influenceIdLevelModalOpen(...args)))
                        }, _toDisplayString(_ctx.infoData.influenceIdName), 3)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-right", {'hyper-text-themes': _ctx.modRoleAuth('/aftersale/ticket/works/modOwnerProject', _ctx.infoData.userCode)}]),
                          onClick: _cache[9] || (_cache[9] = $event => (_ctx.userCodeLevelModalOpen(['ownerProject','项目责任人'])))
                        }, _toDisplayString(_ctx.infoData.ownerProjectName || '无'), 3)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-right", {'hyper-text-themes': _ctx.modRoleAuth('/aftersale/ticket/works/modOwnerMain', _ctx.infoData.userCode)}]),
                          onClick: _cache[10] || (_cache[10] = $event => (_ctx.userCodeLevelModalOpen(['ownerMain','运维责任人'])))
                        }, _toDisplayString(_ctx.infoData.ownerMainName || '无'), 3)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-right", {'hyper-text-themes': _ctx.modRoleAuth('/aftersale/ticket/works/modOwnerInfo', _ctx.infoData.userCode)}]),
                          onClick: _cache[11] || (_cache[11] = $event => (_ctx.userCodeLevelModalOpen(['ownerInfo','信息责任人'])))
                        }, _toDisplayString(_ctx.infoData.ownerInfoName || '无'), 3)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-right", {'hyper-text-themes': _ctx.modRoleAuth('/aftersale/ticket/works/modOwnerIntegrated', _ctx.infoData.userCode)}]),
                          onClick: _cache[12] || (_cache[12] = $event => (_ctx.userCodeLevelModalOpen(['ownerIntegrated','集成责任人'])))
                        }, _toDisplayString(_ctx.infoData.ownerIntegratedName || '无'), 3)
                      ])
                    ])
                  ])
                ])
              ])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createVNode(_component_app_select_level, {
          ref: "userCodeLevel",
          levelType: "onLest",
          levelApi: _ctx.getUserApi,
          selectItem: _ctx.tableRequestItem.lockItem.userCode,
          maxParentId: _ctx.authUser.orgCode,
          selectFunction: _ctx.userCodeLevelFunction,
          searchFieldList: _ctx.userCodeLevelSearchField
        }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
        _createVNode(_component_app_model_textarea, {
          ref: "workDescribeLaunchModal",
          value: _ctx.infoData.workDescribeLaunch,
          rows: "8",
          title: "修改发起详情",
          label: "发起详情",
          submitFunction: _ctx.workDescribeLaunchFunction
        }, null, 8, ["value", "submitFunction"]),
        _createVNode(_component_app_model_textarea, {
          ref: "workDescribeProcessModal",
          value: _ctx.infoData.workDescribeProcess,
          rows: "8",
          title: "修改处理详情",
          label: "处理详情",
          submitFunction: _ctx.workDescribeProcessFunction
        }, null, 8, ["value", "submitFunction"]),
        _createVNode(_component_app_select_level, {
          ref: "influenceIdLevel",
          levelType: "select",
          levelApi: _ctx.getInfluenceApi,
          selectItem: _ctx.tableRequestItem.lockItem.influenceId,
          selectFunction: _ctx.influenceIdLevelFunction,
          searchFieldList: _ctx.influenceIdLevelSearchField
        }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
        _createVNode(_component_app_select_level, {
          ref: "businessIdLevel",
          levelType: "select",
          levelApi: _ctx.getBusinessApi,
          selectItem: _ctx.tableRequestItem.lockItem.businessId,
          selectFunction: _ctx.businessIdLevelFunction,
          searchFieldList: _ctx.businessIdLevelSearchField
        }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"])
      ])
    ]),
    _: 1
  }, 8, ["title", "loading", "onUpdate:modelOpened", "onUpdate:modelClosed"]))
}